import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '~/hooks/useAppSelector';
import {
  fetchFavoriteProfessionals,
  fetchHighlyRatedProfessionals,
  fetchRecentProfessionals,
  hideJobsInvitePopup,
} from '~/actions';
import Portal from '../commonComponents/Portal';
import { InviteProfessionalPopup } from '../commonComponents/InviteProfessional/Popup';

export const JobsInviteSelectionPopup = () => {
  const dispatch = useDispatch();
  const hasFetchedProfessionals = useRef(false);
  const { showSelection, jobIds, profession } = useAppSelector(
    (state) => state.multiday.jobsInvitePopup,
  );
  const { favoriteProfessionals, recentProfessionals, highlyRatedProfessionals } = useAppSelector(
    (state) => state.user,
  );

  useEffect(() => {
    if (!showSelection || hasFetchedProfessionals.current) return;

    if (!favoriteProfessionals.length) {
      dispatch(fetchFavoriteProfessionals());
    }

    if (!recentProfessionals.length) {
      dispatch(fetchRecentProfessionals());
    }

    if (!highlyRatedProfessionals?.data?.length) {
      dispatch(fetchHighlyRatedProfessionals({ page: 1, limit: 20 }));
    }

    hasFetchedProfessionals.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSelection, dispatch]);

  if (!showSelection || !jobIds?.length) {
    return null;
  }

  return (
    <Portal>
      <div onClick={(e) => e.stopPropagation()}>
        <InviteProfessionalPopup
          isOpen
          isRefetchJob={false}
          jobIds={jobIds}
          profession={profession}
          onClose={() => dispatch(hideJobsInvitePopup())}
        />
      </div>
    </Portal>
  );
};
